<template>
  <div class="startpage">
    <div class="container container-float container-fixed container-header" :class="{'container-shadow': $root.isScrolled}">
      <div>
          <div class="container-float-left">  
            <div class="logo"></div>
          </div>
          <div class="container-float-right">
            <div class="language" style="text-align: right;">
              <a :class="{'language-active': $root.language == 0}" href="//lexikon.a-d-s.ch">DE</a>
              <a :class="{'language-active': $root.language == 1}" href="//repertoire.a-d-s.ch">FR</a>
              <a :class="{'language-active': $root.language == 2}" href="//lessico.a-d-s.ch">IT</a>
              <a :class="{'language-active': $root.language == 3}" href="//encyclopedia.a-d-s.ch">EN</a>
            </div>
            <div class="small"  style="text-align: right;">
              <a v-on:click="$root.loginmodal()" v-if="!$root.logindata.token" v-html="$root.t('startpage:showlogin')"></a>
              <a v-on:click="$root.logout()" v-if="$root.logindata.token" v-html="$root.t('startpage:logout')"></a>
              <router-link :to="'/account'" v-if="$root.logindata.token" v-html="$root.t('startpage:account')"></router-link>
            </div>
          </div>
          <div class="container container-small container-nopadding container-desktop logotype"><span v-html="$root.t('startpage:logotext')"></span></div>
        </div>
    </div>
      
    
    <div class="container-includestaticfooter">
      <div class="container  container-nopaddinghorizontal container-afterheader">
        
        <div v-if="$root.logindata.token" class="container container-small container-float">
          <h1 v-html="`${$root.t('startpage:welcome')}, ${$root.logindata.message}`"></h1>
          <div class="container-column container-column-left">
            <router-link tag="input" style="width:100%" :to="'/profile'" type="submit" :value="$root.t('startpage:button:profile')"></router-link>
          </div>
          <div class="container-column container-column-right">
            <router-link tag="input" style="width:100%" :to="'/dashboard'" type="submit" :value="$root.t('startpage:button:dashboard')"></router-link>
          </div>
        </div>
        
        
        <transition name="container-overlay">
          <div class="container-overlay" v-if="searching"></div>      
        </transition>
        <div class="container container-small">      
          <form @submit="submit">
            <transition-group name="fade">
              <table  v-if="$root.formdata.mode === 'simple'" v-bind:key='0'>
                <tr class="forceoneline">
                  <td><label v-html="$root.t('startpage:filter')"></label></td>
                  <td class="entry-float-title">
                    <a class="decorated decorated-margin" :class="{'decorated-active': $root.formdata.simple.filter == 'person'}"         v-on:click="switchSimpleForm('person');" v-html="$root.t('startpage:onlyperson')"></a>
                    <a class="decorated decorated-margin" :class="{'decorated-active': $root.formdata.simple.filter == 'work'}"        v-on:click="switchSimpleForm('work');" v-html="$root.t('startpage:onlyworks')"></a>
                    <a class="decorated decorated-margin" :class="{'decorated-active': !$root.formdata.simple.filter}"        v-on:click="switchSimpleForm(false);" v-html="$root.t('startpage:volltext')"></a>
                    <a class="info" :class="{'info-active': help}" v-on:click="help = !help">?</a>
                  </td>
                </tr>
                <transition name="fade">
                  <tr class="infotext" v-if="help">
                    <td></td>
                    <td v-html="$root.t(`startpage:infotext_${$root.formdata.simple.filter}`)">
                    </td>
                  </tr>
                </transition>
                <tr>
                  <td>
                    <label v-html="$root.t('startpage:suchbegriff')"></label>
                  </td>
                  <td v-if="$root.formdata.simple.filter == 'person'">
                    <input class="inlineblock" v-model="$root.formdata.simple.q[0]" name="q0" type="text" :placeholder="$root.t(`startpage:suchfeld_placeholder_name_${$root.formdata.simple.filter}`)">
                    <input class="inlineblock"  v-model="$root.formdata.simple.q[1]" name="q1" type="text" :placeholder="$root.t(`startpage:suchfeld_placeholder_vorname_${$root.formdata.simple.filter}`)">
                  </td>
                  <td colspan="2" v-else>
                    <input v-model="$root.formdata.simple.q[0]" name="q" type="text" :placeholder="$root.t(`startpage:suchfeld_placeholder_${$root.formdata.simple.filter}`)">
                  </td>
                </tr>
                <tr class="angebot" v-if="$root.formdata.simple.filter == 'person'">
                  <td class="angebote-toggle" :class="{'angebote-toggle-active': angebot_toggle}"><label v-html="$root.t('startpage:dienstleistung')" v-on:click="angebot_toggle = !angebot_toggle"></label></td>
                  <td class="angebote" :class="{'angebote-active': angebot_toggle}">
                    <a class="tag" :class="{'tag-active': s.active}" v-on:click="clicktag(s)" v-for="s in $root.categories.services_parsed" v-html="s.translation[$root.language]" v-bind:key="s.id"></a>
                  </td>
                </tr>
                <tr  v-if="$root.formdata.simple.services[619]" class="nomargin">
                  <td><label v-html="$root.t('startpage:übersetzer')"></label></td>
                  <td>
                    <ExtendedFormField v-bind:values="$root.extended_form.translator" v-bind:block="true" v-bind:hidetitle="true" v-bind:data="$root.extended_form_fields.translator" v-bind:model="$root.formdata.simple.translator" v-bind:dynamic="false"/>
                  </td>
                </tr>    
                <tr  class="nomargin" v-if="($root.formdata.simple.services[619] && Object.keys($root.formdata.simple.services).length > 1) || (!$root.formdata.simple.services[619] && Object.keys($root.formdata.simple.services).length > 0)">
                  <td><label v-html="$root.t('startpage:language')"></label></td>
                  <td>
                    <ExtendedFormField v-bind:values="$root.extended_form.language" v-bind:hidetitle="true" v-bind:data="$root.extended_form_fields.language" v-bind:model="$root.formdata.simple.language" v-bind:dynamic="false"/>
                  </td>
                </tr>    
                <tr  v-if="Object.keys($root.formdata.simple.services).length > 0">
                  <td><label v-html="$root.t('startpage:location')"></label></td>
                  <td>
                    <ExtendedFormField v-bind:values="$root.extended_form.location" v-bind:block="true" v-bind:hidetitle="true" v-bind:data="$root.extended_form_fields.location" v-bind:model="$root.formdata.simple.location" v-bind:dynamic="false"/>
                  </td>
                </tr>    
              </table>



              <table v-if="$root.formdata.mode === 'extended'"  v-bind:key='1'>
                <tr class="forceoneline">
                  <td><label v-html="$root.t('startpage:filter')"></label></td>
                  <td>
                    <a class="decorated decorated-margin" :class="{'decorated-active': $root.formdata.extended.filter == 'person'}" v-on:click="$root.formdata.extended.filter = 'person'; $root.extended_form_fields.person.werk = [];" v-html="$root.t('startpage:onlyperson')"></a>
                    <a class="decorated decorated-margin" :class="{'decorated-active': $root.formdata.extended.filter == 'book'}"   v-on:click="$root.formdata.extended.filter = 'book'; $root.extended_form_fields.werk = [];" v-html="$root.t('startpage:onlybooks')"></a>
                    <a class="decorated decorated-margin" :class="{'decorated-active': $root.formdata.extended.filter == 'other'}"  v-on:click="$root.formdata.extended.filter = 'other';  $root.extended_form_fields.other = [];" v-html="$root.t('startpage:onlyother')"></a>
                  </td>
                </tr>

                <tr v-if="$root.formdata.extended.filter == 'book'">
                  <td><label v-html="$root.t('startpage:book')"></label></td>
                  <td>
                    <ExtendedFormField v-bind:key="$root.formdata.extended.filter" v-bind:values="$root.extended_form.werk" v-bind:data="$root.extended_form_fields.werk" v-bind:model="$root.formdata.extended" v-bind:dynamic="true"/>
                  </td>
                </tr>
                <tr v-if="$root.formdata.extended.filter == 'other'">
                  <td><label v-html="$root.t('startpage:werk')"></label></td>
                  <td>
                    <ExtendedFormField v-bind:key="$root.formdata.extended.filter" v-bind:values="$root.extended_form.other" v-bind:data="$root.extended_form_fields.other" v-bind:model="$root.formdata.extended" v-bind:dynamic="true"/>
                  </td>
                </tr>
                <tr  v-if="$root.formdata.extended.filter == 'person'">
                  <td><label v-html="$root.t('startpage:person')"></label></td>
                  <td>
                    <ExtendedFormField v-bind:key="$root.formdata.extended.filter" v-bind:values="$root.extended_form.person" v-bind:data="$root.extended_form_fields.person" v-bind:model="$root.formdata.extended" v-bind:dynamic="true"/>
                  </td>
                </tr>            
              </table>
            </transition-group>            
            <table>
              <tr>
                <td class="modeswitch">
                  <template v-if="$root.formdata.mode === 'simple'">
                    <a class="decorated" v-on:click="formMode('extended')"  v-html="$root.t('startpage:erweiterte_suche')"></a>
                  </template>
                  <a class="decorated" v-else v-on:click="formMode('simple')"  v-html="$root.t('startpage:vereinfachte_suche')"></a>
                </td>
                <td>
                  <input type="hidden" :value="$root.formdata.mode">
                  <input style="float: right" type="submit" :value="$root.t('startpage:submit')">
                </td>
              </tr>
            </table>
          </form>
        </div>
      </div>
      <div class="container container-small container-bordertop" style="padding-bottom: 4em;">
        <div v-html="$root.t('startpage:column_left')"></div>
      </div>
    </div>
    <StaticFooter/>
  </div>
</template>

<style lang="scss">
  @import "../main";
  .startpage {

    .fade-enter-active {
      transition: opacity .5s;
    }
    .fade-leave-active {
      position: absolute;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    .container-afterheader {
      padding-top: 8.2em;
      @include st() {
        padding-top: $padding * 4.2;
      }

    }

    .footer-col {
      img {
        max-width: 18em;
        max-height: 6em;
        margin-bottom: $padding
      }
    }    

    .tag {
      /*@include sm() {
        width: 100%;
      }*/
    }

    .angebote {
      .tag {
        @include smallfont();
        padding: $padding/3 $padding/2 $padding/4;
        margin-right: 0.5em;
        margin-bottom: 0.5em;
      }
    }

    @include sm() {
      .angebot {
        margin-bottom: 1em;
        .angebote {
          display: none;
          &-active {
            display: table-cell;
          }
          &-toggle {
            width: 100%;
            padding: $padding / 2 $padding;
            margin-right: $padding;
            margin-bottom: $padding;
            line-height: $padding;
            display: inline-block;
            user-select: none;
            cursor: pointer;
            border-radius: 3px;
            transition: all 0.1s;
            font-weight: normal;
            border: 1px solid;
            color:  $inactive-color;
            background: $background-inactive;
            &-active {
              color: $active-color;
              border-color: $active-color;
              background: $background-highlight;
              label {
                &:before,
                &:after {
                  content: " ";
                  position: absolute;
                  right: 0em;
                  top: 0.5em;
                  width: 1em;
                  height: 1px;
                  background: black;
                  display: block;
                  transform: rotate(45deg);
                }
                &:after {
                  transform: rotate(-45deg);
                }
              }
            }
            label {
              width: 100%;
              cursor: pointer;
              display: block;
              position: relative;
              margin: 0px;
              padding: 0px;
            }
          }
        }
      }
    }

    form {
      position: relative;
      @include st() {
        input[type="submit"] {
          width: 100%;
        }
        .small {
          a {
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
    table {
      width: 100%;
      border-collapse: collapse;
      tr.infotext {
        td {
          padding: 0;
        }
        p {
          padding: 0;
          margin: 0;
          margin-top: -1em;
          min-height: 4em;
          @include smallfont;
          @include st() {
            margin-bottom: 1em;
          }
        }
      }
      tr.nomargin {
        td {
          padding-bottom: 0em;
          margin-bottom: 0em;
        }
        .extended_field {
          margin-bottom: -1em;
        }
      }
      td {
        padding: $padding 0;
        vertical-align:text-top;
        &:first-child {
          min-width: 200px;
          padding-right: $padding;
        }
        &:last-child {
          width: 100%;
          padding-right: 0px;
        }
        &.modeswitch {
          white-space: nowrap;
          vertical-align: middle;
          a {
            @include smallfont;
            margin-right: $padding;
            @include st() {
              @include regularfont;
            }
          }
        }
      }
      @include st() {
        td, tr {
          display: block;
          padding-top: 0;
        }
        tr.forceoneline {

         td:last-child {
           margin-left: -0.25em;
           margin-right: -0.25em;
           width: auto;
           a.info {
             position: absolute;
             top: 0em;
             right: 0em;
           }
           a.decorated {
            padding: $padding / 2 0;
            line-height: $padding;
            display: inline-block;
            user-select: none;
            cursor: pointer;
            border-radius: 3px;
            white-space: nowrap;
            overflow: hidden;
             display: inline-block;
             width: calc(33.3% - 0.5em);
             box-sizing: border-box;
             border: 1px solid;
             margin: 0 0.25em;
             text-align: center;
           }
         }
        }
      }
    }
  }
</style>

<script>

import ExtendedFormField from '@/components/ExtendedFormField.vue'
import StaticFooter from '@/components/StaticFooter.vue'

export default {
  name: 'startpage',
  components: {
    ExtendedFormField,
    StaticFooter
  },
  data() {
    return {
      searching: false,
      angebot_toggle: false,
      help: false
    }
  },

  methods: {
    formMode(mode) {
      this.$root.formdata.mode = mode;
      this.$router.replace(mode == 'extended' ? '/extended' : '/');
    },


    switchSimpleForm(mode) {
      this.$root.formdata.simple = {
        q: [],
        services: {},
        translator: {},
        language: {},
        location: {}
      };
      
      for (let _token in this.$root.categories.services_parsed) if (this.$root.categories.services_parsed.hasOwnProperty(_token)) {
       this.$root.categories.services_parsed[_token].active = false;
      }

      this.$root.formdata.simple.filter = mode;
    },
    async submit(e) {
      e.preventDefault();
      if (this.$root.formdata.mode === 'extended' && Object.keys(this.$root.formdata.extended).length === 0) {
        alert(this.$root.t('search:alert:extended:missing'));
        return;
      }
      /*if (this.$root.formdata.mode === 'simple' && (this.$root.formdata.simple.q[0] === "" && Object.keys(this.$root.formdata.simple.services).length === 0)) {
        alert(this.$root.t('search:alert:simple:missing'));
        return;
      }*/
      this.searching = true;
      this.$root.formdata.offset = 0;
      this.$root.result = await this.$store.dispatch('post', {
                          mode: '/search', 
                          params: this.$root.formdata,
                          headers: {
                            'Content-type': 'application/json',
                          }
                      });
      this.searching = true;
      if (this.$root.result !== false) {
        this.$router.push({ name: 'searchresults' })
      }  
      return false;
    },
    clicktag(tag) {

      if (!tag.active && Object.keys(this.$root.formdata.simple.services).length > 2) {
        alert(this.$root.t('startpage:alert:max3angebote'));
        return;
      }
      


      tag.active = !tag.active
      if (this.$root.formdata.simple.services[tag.id]) {
        delete this.$root.formdata.simple.services[tag.id]
      }
      else {
        this.$root.formdata.simple.services[tag.id] = tag.id;
      }
    }
  }
}
</script>
